import { api, throwApiError } from "../../api/api";

export type ControlColor = "VERDE" | "LARANJA" | "VERMELHO";

export type FreelancerControlRow = {
  freelancerId: string;
  fullName: string;
  contato: string | null;
  cpf: string;
  day: string;
  startDay: string;
  endDay: string;

  acompanhamento: ControlColor;

  registrationStatus: string | null;
  slotIsCanceled: boolean;

  storeToWorkId: string | null;
  storeToWorkName: string | null;
  finalValue: string | null;
  stars: number | null;
};

export type PaginatedFreelancerControlResponse = {
  items: FreelancerControlRow[];
  page: number;
  limit: number;
  total: number;
  startDay: string;
  endDay: string;
};

export const getFreelancersControlApi = async (
  token: string,
  params: {
    page: number;
    limit: number;
    startDay: string;
    endDay: string;
    nome?: string;
    priorityStoreId?: string | null;
  }
): Promise<PaginatedFreelancerControlResponse> => {
  const rawToken = token?.startsWith("Bearer ") ? token.slice(7) : token;

  try {
    const { data } = await api.get<PaginatedFreelancerControlResponse>("/freelancers/control", {
      params: {
        page: params.page,
        limit: params.limit,
        startDay: params.startDay,
        endDay: params.endDay,
        nome: params.nome?.trim() || undefined,
        priorityStoreId: params.priorityStoreId || undefined,
      },
      headers: { Authorization: `Bearer ${rawToken}` },
    });
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao carregar controle de freelancers.");
    throw error;
  }
};
